import { STORAGE_KEY, STATE_KEYS_TO_SAVE } from "constants/SiteConstants";

export const persistedState = (() => {
  try {
    const rawState = localStorage.getItem(STORAGE_KEY);
    if (rawState === null) return undefined;
    const state = JSON.parse(rawState);
    return state;
  } catch (err) {
    return undefined;
  }
})();

export const saveState = (state) => {
  try {
    let stateFilter = JSON.parse(JSON.stringify(state));
    for (const key of Object.keys(stateFilter)) {
      if (!STATE_KEYS_TO_SAVE.includes(key)) {
        delete stateFilter[key];
      }
    }
    const rawState = JSON.stringify(stateFilter);
    localStorage.setItem(STORAGE_KEY, rawState);
  } catch (err) {
    // Ignore write errors.
  }
};
